/**
 * <s-buy-bar> — fixed bottom bar on small screens with the price and the main action.
 * It slides in once the main add-to-bag button ([data-buy-anchor]) has scrolled out of view
 * above the viewport, and hides again when the button is back on screen.
 * The bar lives inside the product form, so its button submits the same form.
 */
class SBuyBar extends HTMLElement {
  #observer;

  connectedCallback() {
    const anchor = document.querySelector('[data-buy-anchor]');
    if (!anchor) return;
    this.#observer = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.toggleAttribute('data-visible', passed);
      this.inert = !passed;
    });
    this.inert = true;
    this.#observer.observe(anchor);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-buy-bar')) {
  customElements.define('s-buy-bar', SBuyBar);
}
